/*global VeloxGridAndFormController, VeloxWebView, VeloxFormController*/
var upload = require("./upload") ;


var ControllerWithImage = function(table, options){

    VeloxGridAndFormController.call(this, table, options) ;
    
    var schema = VeloxWebView.fieldsSchema.getSchema();
    if(schema[table].pk.length > 1){
        throw "Can't manage image on record with many PK" ;
    }

    var pk = schema[table].pk[0] ;
    var joinFetchBinary = { 
        otherTable: "velox_binary", 
        thisField: pk, otherField: "table_uid", name: "binary", joinSearch: {table_name:table}} ;
    if(!this.formController.joinFetch){
        this.formController.joinFetch = [joinFetchBinary] ;
    }else{
        this.formController.joinFetch.push(joinFetchBinary) ;
    }

    this.formController.getRecordsToDelete = function(record, callback){
        VeloxFormController.prototype.getRecordsToDelete.call(this, record, function(err, records){
            if(err){ return callback(err) ;}
            records.push(
                {action : "removeWhere", table: "velox_binary", record:  {table_name:table, table_uid: record[pk]}}
            ) ;
            callback(null, records) ;
        }) ;
    };

    this.formController.saveRecords = function(recordsToSave, callback){
        VeloxFormController.prototype.saveRecords.call(this, recordsToSave, function(err, result){
            if(err){ return callback(err) ;}
            if(this.data.file){
                var binaryRecord = {
                    table_name: table, 
                    table_uid: this.data[pk], 
                    mime_type: this.data.file.type,
                    description : this.data.file.name,
                    filename: "image"
                };
                if(this.data.binary){
                    binaryRecord.uid = this.data.binary.uid ;
                }
                this.api.saveBinary(
                    this.data.file,
                binaryRecord, function(err, binary){
                    if(err){ return callback(err) ;}
                    this.data.binary = binary ;
                    this.view.render() ;
                    callback(null, result) ;
                }.bind(this)) ;
            }else{
                callback(null, result) ;
            }
        }.bind(this)) ;
    } ;
    

    this.formController.onUpload = function(){
        upload({
            multiple: false, 
            accept: options.form.fileAccept||"image/jpg,image/png,image/gif",
            sizeLimit: options.form.sizeLimit||600000
        },function(file){
            if(!file){ return ;}
            this.data.file = file ;
            this.view.longTask(function(done){

                this.loadImageFile(file, done) ;
                
            }.bind(this)) ;
        }.bind(this));
    } ;

    this.formController.loadImageFile = function(file, done){
        var reader = new FileReader();

        reader.onload = function (e) {
            this.view.EL.image.src = e.target.result ;
            this.view.EL.image.className = this.view.EL.image.className.replace(" d-none", "") ;
            this.view.EL.noImage.className += " d-none" ;
            done() ;
        }.bind(this);

        reader.readAsDataURL(file);
    } ;

} ;

ControllerWithImage.prototype = Object.create(VeloxGridAndFormController.prototype);
ControllerWithImage.prototype.constructor = ControllerWithImage;


module.exports = ControllerWithImage;